/*
 * Copyright 1999-2024 Jagex Ltd.
 */
// eslint-disable-next-line
import { Global } from '@emotion/core';
import { ThemeProvider } from '@jagex/design_runescape';
import React, { FunctionComponent } from 'react';
import TagManager from 'react-gtm-module';
import { MainContainer } from '@components/layouts';
import { Store } from '@stores/Store';
import { StoreProvider } from '@stores/StoreProvider';
import { AppRouter } from 'AppRouter';
import { GlobalStyle } from './common';
import { I18n } from './i18n';

// Google Tag Manager (GTM) tracking arguments
const tagManagerArgs = {
  gtmId: 'GTM-NRKJSQ',
  dataLayer: {
    site: 'dual'
  }
};

// Google Tag Manager (GTM) tracking arguments
TagManager.initialize(tagManagerArgs);

interface Props {
  store: Store;
  i18nInstance: I18n;
}

// TODO: Remove Global and GlobalStyle and rely on design_runescape for styles
const App: FunctionComponent<Props> = ({ store, i18nInstance }) => (
  <StoreProvider store={store}>
    <ThemeProvider>
      <Global styles={GlobalStyle} />
      <MainContainer>
        <AppRouter i18nInstance={i18nInstance} />
      </MainContainer>
    </ThemeProvider>
  </StoreProvider>
);

export default App;
